export const accordionWrapStyle = {
  background: '#F1F5FF',
  borderRadius: '10px',
  padding: '10px',
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
}

export const accordionHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0 10px',
  cursor: 'pointer',
  gap: '5px',
}

export const categoryLabelStyle = {
  fontSize: '12px',
  fontWeight: 700,
  fontFamily: 'Open Sans',
  color: '#121212',
}

export const chevronStyle = open => ({
  display: 'inline-flex',
  width: '12px',
  height: '12px',
  flexShrink: 0,
  transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: 'transform 0.2s ease',
  marginLeft: '6px',
  marginRight: '8px',
})
